import React from 'react';
import { Routes, Route } from 'react-router-dom';
import DashboardLayout from '@/components/DashboardLayout';
import ResidentHome from './ResidentHome';
import ResidentComplaints from './ResidentComplaints';
import ResidentAmenities from './ResidentAmenities';
import ResidentBills from './ResidentBills';
import ResidentVisitors from './ResidentVisitors';
import ResidentChat from './ResidentChat';
import ResidentTenants from './ResidentTenants';
import ResidentAnnouncements from './ResidentAnnouncements';
import Forum from '@/pages/Forum';
import Events from '@/pages/Events';

const ResidentDashboard = () => {
  return (
    <DashboardLayout role="resident">
      <Routes>
        <Route index element={<ResidentHome />} />
        <Route path="complaints" element={<ResidentComplaints />} />
        <Route path="amenities" element={<ResidentAmenities />} />
        <Route path="bills" element={<ResidentBills />} />
        <Route path="visitors" element={<ResidentVisitors />} />
        <Route path="tenants" element={<ResidentTenants />} />
        <Route path="chat" element={<ResidentChat />} />
        <Route path="announcements" element={<ResidentAnnouncements />} />
        <Route path="forum" element={<Forum />} />
        <Route path="events" element={<Events />} />
      </Routes>
    </DashboardLayout>
  );
};

export default ResidentDashboard;